import { create } from 'zustand';

interface Answer {
    questionNumber: number;
    riskPoints: number;
    optionId: string;
    optionText: string;
    questionText: string;
}

interface RiskQuestionnaireState {
    currentQuestionIndex: number;
    answers: Answer[];
    riskScore: number;
    riskProfile: string | null;
    setCurrentQuestionIndex: (index: number) => void;
    addAnswer: (answer: Answer) => void;
    calculateRiskProfile: () => void;
    resetQuestionnaire: () => void;
}

export const useRiskQuestionnaireStore = create<RiskQuestionnaireState>((set, get) => ({
    currentQuestionIndex: 0,
    answers: [],
    riskScore: 0,
    riskProfile: null,
    setCurrentQuestionIndex: (index) => set({ currentQuestionIndex: index }),
    addAnswer: (answer) => {
        set((state) => {
            // Use a Map for O(1) lookup instead of O(n) filter
            const answersMap = new Map(state.answers.map(a => [a.questionNumber, a]));
            answersMap.set(answer.questionNumber, answer);
            return { answers: Array.from(answersMap.values()) };
        });
    },
    calculateRiskProfile: () => {
        const { answers } = get();
        const riskData = [
            { questionNumber: 1, weightage: 40 },
            { questionNumber: 2, weightage: 15 },
            { questionNumber: 3, weightage: 40 },
            { questionNumber: 4, weightage: 5 },
        ];

        let totalScore = 0;
        answers.forEach(answer => {
            const questionData = riskData.find(q => q.questionNumber === answer.questionNumber);
            if (questionData) {
                const questionScore = (answer.riskPoints * questionData.weightage) / 10;
                totalScore += questionScore;
            }
        });

        let riskProfile = '';
        if (totalScore >= 10 && totalScore <= 17) {
            riskProfile = 'Very Conservative';
        } else if (totalScore > 17 && totalScore <= 24) {
            riskProfile = 'Conservative';
        } else if (totalScore > 24 && totalScore <= 34) {
            riskProfile = 'Balanced';
        } else if (totalScore > 34 && totalScore <= 44) {
            riskProfile = 'Aggressive';
        } else if (totalScore > 44 && totalScore <= 50) {
            riskProfile = 'Very Aggressive';
        }

        set({ riskScore: totalScore, riskProfile });
    },
    resetQuestionnaire: () => set({
        currentQuestionIndex: 0,
        answers: [],
        riskScore: 0,
        riskProfile: null,
    }),
}));